type ObjectType = Record<string, any>

export function compareObjectsByProperty(prop: string) {
    return function (a: ObjectType, b: ObjectType) {
        return a[prop].localeCompare(b[prop], undefined, { numeric: true });
    };
}
